import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-ranslation"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20.2494 8.08989C20.2494 7.22438 19.5478 6.52275 18.6823 6.52275C17.8168 6.52275 17.1152 7.22438 17.1152 8.08989V4.75547C17.1152 3.88873 16.4125 3.18609 15.5458 3.18609C14.6791 3.18609 13.9764 3.88873 13.9764 4.75547V2.56938C13.9764 1.70264 13.2738 1 12.407 1C11.5403 1 10.8376 1.70264 10.8376 2.56938V4.75547C10.8376 3.88873 10.135 3.18609 9.26827 3.18609C8.40152 3.18609 7.69888 3.88873 7.69888 4.75547V13.5045V13.5045C7.69888 13.5059 7.69705 13.5041 7.69634 13.5029L6.23528 10.9723C5.96475 10.5037 5.43149 10.2526 4.89795 10.3425C4.14717 10.4691 3.66689 11.2127 3.86031 11.9491L5.1287 16.7783C5.93683 19.855 8.71795 22 11.8991 22H13.2495C17.1154 22 20.2494 18.866 20.2494 15V8.08989Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.1152 8.08989V11M17.1152 8.08989V4.75547C17.1152 3.88873 16.4125 3.18609 15.5458 3.18609C14.679 3.18609 13.9764 3.88873 13.9764 4.75547M17.1152 8.08989C17.1152 7.22439 17.8168 6.52275 18.6823 6.52275C19.5478 6.52275 20.2494 7.22439 20.2494 8.08989V15C20.2494 18.866 17.1154 22 13.2494 22H11.8991C8.71795 22 5.93683 19.855 5.1287 16.7783L3.86031 11.9491C3.66689 11.2127 4.14717 10.4691 4.89795 10.3425C5.43149 10.2526 5.96475 10.5037 6.23528 10.9723L7.69703 13.5041C7.69722 13.5044 7.6976 13.5046 7.69799 13.5046V13.5046C7.6985 13.5045 7.69888 13.5041 7.69888 13.5036V4.75547C7.69888 3.88873 8.40152 3.18609 9.26827 3.18609C10.135 3.18609 10.8376 3.88873 10.8376 4.75547M13.9764 4.75547V11M13.9764 4.75547V2.56938C13.9764 1.70264 13.2738 1 12.407 1C11.5403 1 10.8376 1.70264 10.8376 2.56938V4.75547M10.8376 4.75547V11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureRanslation = Vue.extend<IconProps>({
  name: 'GestureRanslationIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-ranslation',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureRanslation;
